module.exports = __webpack_public_path__ + "static/media/requests-active.b772ac0e.svg";